<template>

	<div class="galist_wbox bkf7">
		<div class="inter">
			<div class="wbox">
				<h1 class="h1"><span>全部游戏</span></h1>
				<ul class="gamelist_ul">
					<li v-for="(item, index) in $store.state.gamelist">
						<router-link :to="{path: 'game', query: {gtype: item.id,is_zu:1}}">
							<div class="image">
								<img :src="'http://img.h6ds.com'+item.image3" />
							</div>

							<p>{{item.name}}</p>
						</router-link>
					</li>
				</ul>
			</div>
		</div>
	</div>

</template>


<script>
	export default {
		data() {
			return {
				list: [],
				content: "",
				active: 0,
				title: "",
			}
		},
		created: function(data) {

			this.getmenu();

		},
		watch: {
			$route() {

			}
		},
		methods: {
			chose(index) {
				this.$data.active = this.$data.list[index].id;
				this.content = this.$data.list[index].content;
			},
			getmenu() {
				var that = this;
				this.rq.requests.post("api/hall/getchives", {
					id: 46,
				}).then(res => {
					that.$data.list = res.data;
					if (that.$data.list.length > 0) {
						that.$data.active = that.$data.list[0].id;
						that.content = that.$data.list[0].content;
						that.title = that.$data.list[0].title;
					}

				}).catch(error => {
					
				})
			},

		}


	}
</script>
